import React, { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion/dist/framer-motion";
import { Container, Row, Col } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import cx from "classnames";
import _ from "lodash";

import JoinNow from "pages/lobby/joinNow";
import * as paramsAction from "redux/gameParams/actions";
import * as loaderAction from "redux/loader/action";
import Socket from "socket/socket";
import Alert from "../shared/common/alert";

import CcStart from "../smallBites/sayWhat/CcStart";
import Voting from "../smallBites/sayWhat/Voting";
import ShowCase from "../smallBites/sayWhat/ShowCase";
import CcOver from "../smallBites/sayWhat/CcOver";

import LtOver from "../smallBites/lightingTrivia/Over";
import LtQuestion from "../smallBites/lightingTrivia/Question";
import ChooseAsker from "./lightingTrivia/ChooseAsker";

import PreGuess from "./totSBS/PreGuess";
import Guessing from "./totSBS/Guessing";
import Tot_Over from "./totSBS/Tot_Over";
import Guessing_OverTTL from "./ttl/Guessing_OverTTL";
import ChooseAskerTTL from "./ttl/ChooseAskerTTL";
import WellnessLibrary from "./wellness/wellnessLibrary";

const SmallBitesLobby = (props) => {
  const roomData = _.get(props, "gameReducer.roomObj");
  const game_state = _.get(roomData, "game_state");
  const captionsArray = _.get(roomData, "game_state.captions");
  const totRightWords = _.get(roomData, "game_state.right_words");
  const users = _.get(props, "gameReducer.roomObj.users");
  const status = _.get(roomData, "game_state.status");
  const playerArray = _.get(roomData, "game_state.player");
  const [answeredArrayy, setansweredArrayy] = useState([null]);
  const [secondsArray, setsecondsArray] = useState([]);
  const [loadUploadQuestions, setLoadUploadQuestions] = useState(false);
  const [cc_countdown, set_cc_countdown] = useState(null);
  const correct_answer_number = _.get(
    roomData,
    "game_state.question.correct_answer"
  );
  const gameCode = _.get(props, "gameReducer.roomObj.game_code");
  const paramsReducerr = _.get(props, "paramsReducer.gameObj");
  const sub_game_code = _.get(game_state, "sub_game_code");
  const editions = _.get(props, "socketReducer.editions");
  const LT_backgrounds = _.get(props, "socketReducer.LT");
  const mobileUrl = _.get(props, "paramsReducer.gameObj.url_link");
  const mobileUrl2 = _.get(props, "paramsReducer.gameObj.tabletop.url_link");
  const ttl_chooseasker_params = _.get(
    props,
    "paramsReducer.gameObj.ttl.tabletop.0_chooseasker"
  );
  const ttl_guessing_params = _.get(
    props,
    "paramsReducer.gameObj.ttl.tabletop.1_guessing"
  );
  const ttl_over_params = _.get(
    props,
    "paramsReducer.gameObj.ttl.tabletop.2_over"
  );
  const volumeLevel = _.get(props, "socketReducer.volume");
  const deadline_time = _.get(game_state, "deadline_time");
  const asker_id = _.get(game_state, "asker");

  const asker = users?.find((user) => user.player_id === asker_id);
  const remainingQuestions = roomData?.game_state?.questions;

  const claeningArray = [];
  let unansweredUsers = [];

  const [winner, setWinner] = useState([]);
  const [selectedAsker, setSelectedAsker] = useState(null);
  const [otherWinners, setOtherWinners] = useState([]);
  const [winnerUserData, setWinnerUserData] = useState([]);
  const [otherWinnersUserData, setOtherWinnersUserData] = useState([]);
  const [min_seconds, setMinSecond] = useState();
  const [timerScreen, setTimerScreen] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [correctlyAnsweredPlayers, setCorrectlyAnsweredPlayers] = useState([]);

  const bars = document.querySelectorAll(".bar");
  const progress = document.querySelectorAll(".progress");
  const callAudio = document.getElementById("playAudioTrack");

  bars.forEach((bar, index) => {
    const randomWidth = Math.floor(Math.random() * 65 + 10);
    bar.style.width = `${randomWidth}%`;

    progress[index].addEventListener("mouseover", () => {
      const randomTiming = Math.floor(Math.random() * 2 + 2);
      bar.style.transitionDuration = `${randomTiming}s`;
      bar.style.width = "100%";
    });
  });

  useEffect(() => {
    if (!!deadline_time) {
      set_cc_countdown(30);
    }
  }, [deadline_time]);

  useEffect(() => {
    let timer;
    if (cc_countdown > 0) {
      timer = setInterval(() => set_cc_countdown(cc_countdown - 1), 1000);
    } else if (cc_countdown == 0 && status === "Showcase") {
      onTimesUp();
    }
    return () => clearInterval(timer);
  }, [cc_countdown]);

  useEffect(() => {
    if (secondsArray && secondsArray.length > 0) {
      const minimum_seconds = Math.min(...secondsArray);
      setMinSecond(minimum_seconds);
    }
  }, [secondsArray]);

  useEffect(() => {
    if (playerArray && playerArray.length > 0) {
      let temp = playerArray.filter((item) => {
        return item.answer === correct_answer_number;
      });
      const temp2 = temp.map((item) => item.answer_time);
      setsecondsArray(temp2);
      setCorrectlyAnsweredPlayers(temp);
    }
  }, [playerArray]);

  useEffect(() => {
    if (correctlyAnsweredPlayers && correctlyAnsweredPlayers.length > 0) {
      const temp = correctlyAnsweredPlayers?.filter((item) => {
        if (item.answer_time === min_seconds) {
          return item;
        }
      });
      setWinner(temp);

      const temp2 = correctlyAnsweredPlayers?.filter((item) => {
        if (item.answer_time > min_seconds) {
          return item;
        }
      });
      setOtherWinners(temp2);
    } else {
      setWinner([]);
      setOtherWinners([]);
    }
  }, [correctlyAnsweredPlayers]);

  useEffect(() => {
    if (users && users.length > 0 && winner && winner.length > 0) {
      const temp = users?.filter((item) => {
        for (let elem of winner) {
          if (elem.player_id === item.player_id) {
            return true;
          }
        }
        return false;
      });
      setWinnerUserData(temp);
    } else {
      setWinnerUserData([]);
    }
  }, [winner]);

  useEffect(() => {
    if (users && users.length > 0 && otherWinners && otherWinners.length > 0) {
      let temp = [];
      for (let item of users) {
        for (let elem of otherWinners) {
          if (elem.player_id === item.player_id) {
            temp.push({ ...item, answer_time: elem.answer_time });
          }
        }
      }
      setOtherWinnersUserData(temp);
    }
  }, [otherWinners]);

  useEffect(() => {
    let temp = [];
    playerArray &&
      playerArray.length > 0 &&
      playerArray.forEach((item) => {
        if (item.hasOwnProperty("answer")) {
          temp.push(item);
        } else {
          unansweredUsers.push(item);
        }
      });

    setansweredArrayy(temp);
  }, [playerArray]);

  const { onBack, branchLink } = props;

  const onStartGame = async () => {
    if (users && users.length < 2) {
      Alert(400, "Need at least 2 player to start the game");
      return;
    } else {
      let data = {
        action: "update-status",
        roomId: roomData.id,
        tableTopName: "SB Lighning Trivia",
        directSbsTot: false
      };
      Socket.sendMessage(data);
      props.setIsLoading(true);
      await props.getSubGameData({ game_code: "SBS" });
      props.setIsLoading(false);
    }
  };

  const onTimesUpTot = ({ gameCode }) => {
    if (users && users.length < 2 && gameCode === "TOTO") {
      Alert(400, "Need at least 2 player to start the game");
      return;
    } else {
      let data = {
        action: "update-status",
        roomId: roomData.id,
        tableTopName: "SB Lighning Trivia"
      };
      Socket.sendMessage(data);
    }
  };
  const onTimesUp = () => {
    let data = {
      action: "update-status",
      roomId: roomData.id
    };
    Socket.sendMessage(data);
  };

  const onPlayAgain = () => {
    let data = {
      action: "update-status",
      roomId: roomData.id,
      destination: "Question"
    };

    if (editions?.length > 0) {
      data.editions = editions;
    } else {
      data.editions = ["All", "Global"];
    }
    if (!_.isEmpty(LT_backgrounds)) {
      data.background = LT_backgrounds.background;
      data.background_mobile = LT_backgrounds.background_mobile;
      data.top_logo = LT_backgrounds.top_logo;
      data.top_logo_mobile = LT_backgrounds.top_logo_mobile;
    }

    Socket.sendMessage(data);
    setTimeout(() => {
      setOtherWinnersUserData(claeningArray);
      setWinnerUserData(claeningArray);
      setsecondsArray(claeningArray);
      setWinner(claeningArray);
      setMinSecond();
      setCorrectlyAnsweredPlayers(claeningArray);
    }, 2000);
  };

  const onfinishingBulkQuestions = () => {
    let data = {
      action: "update-status",
      roomId: roomData.id,
      destination: "ChooseAsker"
    };
    Socket.sendMessage(data);
    setSelectedAsker(null);
    setTimeout(() => {
      setOtherWinnersUserData(claeningArray);
      setWinnerUserData(claeningArray);
      setsecondsArray(claeningArray);
      setWinner(claeningArray);
      setMinSecond();
      setCorrectlyAnsweredPlayers(claeningArray);
    }, 1500);
  };

  const cc_onPlayAgain = () => {
    let data = {
      action: "update-status",
      roomId: roomData.id,
      destination: "Start"
    };
    Socket.sendMessage(data);
  };
  const tot_onPlayAgain = () => {
    let data = {
      action: "update-status",
      roomId: roomData.id,
      destination: "PreGuess"
    };
    Socket.sendMessage(data);
  };

  const onHomeBtn = () => {
    let data = {
      action: "update-status",
      roomId: roomData.id,
      destination: `${gameCode === "CC" ? "Start" : "PreGuess"}`
    };
    Socket.sendMessage(data);
  };
  const onStartOver = () => {
    let data = {
      action: "update-status",
      roomId: roomData.id,
      destination: "ChooseAsker"
    };
    setTimeout(() => {
      setOtherWinnersUserData(claeningArray);
      setWinnerUserData(claeningArray);
      setsecondsArray(claeningArray);
      setWinner(claeningArray);
      setMinSecond();
      setCorrectlyAnsweredPlayers(claeningArray);
    }, 2000);
    Socket.sendMessage(data);
  };

  useEffect(() => {
    if (status === "Over") {
      setTimerScreen(false);
      setCountdown(5);
    }
  }, [status]);

  const playTrack = (attr) => {
    const callAudio = document.getElementById("playAudioTrack");
    if (callAudio) {
      callAudio
        .play()
        .then(() => {})
        .catch(() => {});
    }
  };
  useEffect(() => {
    if (callAudio) {
      playTrack("playBuzzTrack");

      callAudio.volume = volumeLevel;
    }
  }, [volumeLevel, callAudio]);

  return (
    <>
      {gameCode === "WELL" && (
        <WellnessLibrary onBack={onBack} history={props.history} />
      )}

      {(gameCode === "LT" || gameCode === "LTS") && (
        <audio
          loop
          id="playAudioTrack"
          src={paramsReducerr?.lt?.tabletop?.background_music}
        />
      )}
      {gameCode !== "WELL" && (
        <div className={`small-bites-lobby  ${gameCode}`}>
          <Container
            fluid
            style={{ height: gameCode === "TOTO" ? "100%" : "unset" }}
          >
            <Row className="p-4 p-md-0 small-bites-row">
              {gameCode !== "WELL" && (
                <Col sm={3} md={3} className="px-2">
                  {gameCode === "TTL" ? (
                    <AnimatePresence exitBeforeEnter>
                      <JoinNow
                        key="join_now"
                        link={branchLink}
                        onBack={onBack}
                        SBS
                        isBackButton
                        type="SBS"
                        sub_game_code={sub_game_code}
                        gameCode={gameCode}
                        className={"small-bites-card barcode"}
                        joinCodeTextClassName="scan_text"
                        mobileUrl={!!mobileUrl ? mobileUrl : mobileUrl2}
                      />
                    </AnimatePresence>
                  ) : (
                    <JoinNow
                      link={branchLink}
                      onBack={onBack}
                      SBS
                      isBackButton
                      type="SBS"
                      sub_game_code={sub_game_code}
                      gameCode={gameCode}
                      className={"small-bites-card barcode"}
                      joinCodeTextClassName="scan_text"
                      mobileUrl={!!mobileUrl ? mobileUrl : mobileUrl2}
                    />
                  )}
                </Col>
              )}
              {!gameCode !== "WELL" && (
                <Col
                  sm={9}
                  md={9}
                  className={`${gameCode === "TOTO" ? "pe-0" : ""}`}
                >
                  <div
                    className={cx(
                      `small-bites-users-wrapper sbs-tot-wrapper ${
                        (gameCode === "LT" || gameCode === "LTS") &&
                        "small-bites-leaderboard-wrapper"
                      } ${gameCode === "TTL" && "ttl-game-wrapper"}`,
                      {
                        loadUploadQuestion:
                          loadUploadQuestions && status === "ChooseAsker"
                      }
                    )}
                  >
                    {status === "Start" && (
                      <CcStart onStartGame={onStartGame} />
                    )}
                    {status === "Showcase" && (
                      <ShowCase
                        cc_countdown={cc_countdown}
                        captionsArray={captionsArray}
                        onTimesUp={onTimesUp}
                        playerArray={playerArray}
                        users={users}
                      />
                    )}
                    {status === "Voting" && (
                      <Voting
                        onTimesUp={onTimesUp}
                        captionsArray={captionsArray}
                      />
                    )}
                    {status === "Over" && gameCode === "CC" && (
                      <CcOver
                        onHomeBtn={onHomeBtn}
                        cc_onPlayAgain={cc_onPlayAgain}
                        users={users}
                        captionsArray={captionsArray}
                      />
                    )}
                    {status === "Question" && (
                      <LtQuestion
                        asker_id={asker_id}
                        roomData={roomData}
                        gameCode={gameCode}
                        sub_game_code={sub_game_code}
                        answeredArray={answeredArrayy}
                        playerArray={playerArray}
                        onTimesUp={onTimesUp}
                        timerScreen={timerScreen}
                        setTimerScreen={setTimerScreen}
                        countdown={countdown}
                        setCountdown={setCountdown}
                      />
                    )}

                    {(status === "ChooseAsker" ||
                      status === "QuestionSubmit") &&
                      gameCode === "LTS" && (
                        <ChooseAsker
                          onTimesUp={onTimesUp}
                          loadUploadQuestions={loadUploadQuestions}
                          roomData={roomData}
                          setLoadUploadQuestions={setLoadUploadQuestions}
                          sub_game_code={sub_game_code}
                          gameCode={gameCode}
                          selectedAsker={selectedAsker}
                          setSelectedAsker={setSelectedAsker}
                        />
                      )}

                    {status === "Over" &&
                      (gameCode === "LT" || gameCode === "LTS") && (
                        <LtOver
                          remainingQuestions={remainingQuestions}
                          onStartOver={onStartOver}
                          sub_game_code={sub_game_code}
                          gameCode={gameCode}
                          winnerUserData={winnerUserData}
                          otherWinnersUserData={otherWinnersUserData}
                          onPlayAgain={onPlayAgain}
                          min_seconds={min_seconds}
                          onHomeBtn={onHomeBtn}
                          answeredArrayy={answeredArrayy}
                          playerArray={playerArray}
                          onfinishingBulkQuestions={onfinishingBulkQuestions}
                        />
                      )}
                    <AnimatePresence exitBeforeEnter>
                      {gameCode === "TTL" &&
                        (status === "ChooseAsker" ? (
                          <ChooseAskerTTL
                            key="ttl_1"
                            users={users}
                            roomId={roomData.id}
                            game_state={game_state}
                            ttl_chooseasker_params={ttl_chooseasker_params}
                          />
                        ) : status === "Guessing" ? (
                          <Guessing_OverTTL
                            key="ttl_2"
                            asker={asker}
                            users={users}
                            status={status}
                            roomId={roomData.id}
                            onTimesUp={onTimesUp}
                            game_state={game_state}
                            ttl_over_params={ttl_over_params}
                            ttl_guessing_params={ttl_guessing_params}
                          />
                        ) : status === "Over" ? (
                          <Guessing_OverTTL
                            key="ttl_3"
                            asker={asker}
                            users={users}
                            status={status}
                            roomId={roomData.id}
                            onTimesUp={onTimesUp}
                            game_state={game_state}
                            ttl_over_params={ttl_over_params}
                            ttl_guessing_params={ttl_guessing_params}
                          />
                        ) : (
                          <></>
                        ))}
                    </AnimatePresence>
                    {status === "Guessing" && gameCode === "TOTO" && (
                      <Guessing
                        totRightWords={totRightWords}
                        onTimesUp={onTimesUp}
                        users={users}
                        sub_game_code={sub_game_code}
                        gameCode={gameCode}
                      />
                    )}
                    {status === "Over" && gameCode === "TOTO" && (
                      <Tot_Over
                        totRightWords={totRightWords}
                        onHomeBtn={onHomeBtn}
                        tot_onPlayAgain={tot_onPlayAgain}
                        onTimesUp={onTimesUp}
                        users={users}
                      />
                    )}
                    {(status === "PreGuess" || status === "JoiningTOT") && (
                      <PreGuess
                        status={status}
                        onTimesUpTot={onTimesUpTot}
                        totRightWords={totRightWords}
                        onTimesUp={onTimesUp}
                        users={users}
                      />
                    )}
                  </div>
                </Col>
              )}
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
  socketReducer: state.socketReducer
});

const mapDispatchToProps = (dispatch) => ({
  setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  getSubGameData: (data) => dispatch(paramsAction.getSubGameData(data))
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SmallBitesLobby);
